import _ from "lodash";
import React from "react";
import CriteriaRating from "UIComponents/CriteriaRating";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./AssessmentIBScaleTool.scss";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import { handleAssessmentIBScaleCriteriaClick } from "ClassRoom/modules/ClassRoomModule";
import { getIsAIGeneratingResponseForTool } from "ClassRoom/modules/ClassRoomSelectors";
import classNames from "classnames";
import AIJustification from "UIComponents/AIJustification";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { TickCircleOpenOutlined } from "@toddle-edu/ds-icons";
import SkeletonLoader from "UIComponents/SkeletonLoader";

const styles = {
  containerStyle: {
    width: "max-content",
  },
  starsTwoFilledIconStyle: {
    color: "var(--interactive-tertiary)",
  },
};

const AssessmentIBScaleTool = props => {
  const {
    isEvaluationEnable = false,
    showRatingContainerInViewMode = false,
    assessmentTool = {},
    parentId,
    parentType,
    isEvaluated,
    studentId,
    studentIds,
    t,
    ibPYPElementRatings,
    handleAssessmentIBScaleCriteriaClick,
    toolStyles = {},
    customRatingElementClass,
    customSelectedRatingElement,
    academicTermId,
    sourceFrom,
    ibPYPElementRatingsLocal,
    setIBPYPElementRatingsLocal,
    isAutoSaveDisabled,
    showUpdatedDesign = false,
    isAiEvaluationEnabled,
    showUpdatedDesignForAIGrading,
    onAcceptAIEvaluation,
    isGeneratingAIResponse,
    userType,
    icon = null,
    collapseJustification = true,
  } = props;

  const isStaff = userType === "staff";

  const aiAssessmentGradeBoundary = _.find(ibPYPElementRatings, {
    ibPYPElementType: "ASSESSMENT_GRADE_BOUNDARY",
    creatorType: "AI",
  });

  const justificationMessage = _.get(
    aiAssessmentGradeBoundary,
    "evaluationJustification.message"
  );

  const isAISelectedCriteria =
    isAiEvaluationEnabled &&
    aiAssessmentGradeBoundary &&
    !aiAssessmentGradeBoundary?.isDeleted &&
    !_.isEmpty(aiAssessmentGradeBoundary?.academicCriteriaValue);

  const showEvaluationJustification =
    isAiEvaluationEnabled && !_.isEmpty(justificationMessage);

  const assessmentToolId = _.get(assessmentTool, "id");

  const aiCriteria = _.find(ibPYPElementRatings, rating => {
    return (
      _.get(rating, "ibPYPElementType") === "ASSESSMENT_GRADE_BOUNDARY" &&
      _.get(rating, "creatorType") === "AI" &&
      !_.get(rating, "isDeleted") &&
      _.get(rating, "academicCriteriaValue")
    );
  });

  const staffCriteria = _.find(ibPYPElementRatings, rating => {
    return (
      _.get(rating, "ibPYPElementId") === assessmentToolId &&
      _.get(rating, "creatorType") === "STAFF"
    );
  });

  const defaultCriteria = _.find(ibPYPElementRatings, rating => {
    return (
      _.get(rating, "ibPYPElementId") === assessmentToolId &&
      (!_.has(rating, "isDeleted") || !_.get(rating, "isDeleted"))
    );
  });

  const selectedCriteria = isAiEvaluationEnabled
    ? aiCriteria || staffCriteria || defaultCriteria
    : staffCriteria || aiCriteria || defaultCriteria;

  const { academicCriteriaValues = [] } = assessmentTool || {};

  const maxRating = _.size(academicCriteriaValues);
  const aiSelectedCriteria = _.get(aiAssessmentGradeBoundary, "value", "");

  const aiEvaluationLabel =
    aiSelectedCriteria && `${aiSelectedCriteria}/${maxRating}`;

  const handleCriteriaClick = criteriaId => {
    const isDeleteAiRatings =
      isAiEvaluationEnabled && selectedCriteria?.creatorType === "AI";

    const { label: score = "" } =
      _.find(academicCriteriaValues, value => {
        return _.get(value, "id") === criteriaId;
      }) || {};

    if (isDeleteAiRatings) {
      onAcceptAIEvaluation({
        ibPypElementId: selectedCriteria?.ibPYPElementId,
        academicTermId,
        ibPYPElementType: "ASSESSMENT_GRADE_BOUNDARY",
        value: score,
      });
    }

    handleAssessmentIBScaleCriteriaClick({
      criteriaId,
      academicCriteriaValues,
      studentIds,
      studentId,
      parentId,
      parentType,
      selectedCriteria,
      isEvaluated,
      assessmentTool,
      academicTermId,
      sourceFrom,
      ibPYPElementRatingsLocal,
      setIBPYPElementRatingsLocal,
      isAutoSaveDisabled,
      isDeleteAiRatings,
    });
  };

  const {
    containerStyle = {},
    leftContainerStyle = {},
    rightContainerStyle = {},
    criteriaRatingStyle = {},
  } = toolStyles || {};

  const leftContainerClasses = classNames({
    ["classes.leftContainer"]: !showUpdatedDesignForAIGrading,
    ["text-label"]: showUpdatedDesign || showUpdatedDesignForAIGrading,
    ["text-label-l"]: !showUpdatedDesignForAIGrading,
  });

  const containerClasses = classNames({
    [classes.container]: !isAiEvaluationEnabled,
    [classes.containerV2]: isAiEvaluationEnabled,
  });

  const toolLabelContainerClasses = classNames({
    [classes.container]: true,
    [classes.minHeight]: isAiEvaluationEnabled,
  });

  const labelElement = (
    <div
      className={leftContainerClasses}
      style={!isAiEvaluationEnabled ? leftContainerStyle : {}}
    >
      {t("common:ib_grade_scale")}
    </div>
  );

  return (
    <div className={containerClasses} style={containerStyle}>
      <div className={toolLabelContainerClasses}>
        {icon ? (
          <div className={classes.iconWithLabelContainer}>
            {icon}
            {labelElement}
          </div>
        ) : (
          labelElement
        )}
        {isAiEvaluationEnabled &&
        !isEvaluated &&
        aiAssessmentGradeBoundary &&
        !isGeneratingAIResponse ? (
          <div className={classes.inlineEvaluationIconContainer}>
            {isAISelectedCriteria ? (
              <Tooltip
                tooltip={t("ai:approve_ai_evaluation", {
                  label: t("common:ib_grade_scale"),
                })}
                dsVersion="2.0"
              >
                <IconButton
                  icon={<TickCircleOpenOutlined />}
                  dsVersion="2.0"
                  variant="neutral"
                  type="plain"
                  size="medium"
                  disabled={!isAISelectedCriteria}
                  onClick={() =>
                    onAcceptAIEvaluation({
                      isAcceptAllForTool: true,
                      academicTermId,
                    })
                  }
                />
              </Tooltip>
            ) : null}
          </div>
        ) : null}
      </div>

      <div className={classes.rightContainer} style={rightContainerStyle}>
        {isGeneratingAIResponse ? (
          <div className={classes.skeletonContainer}>
            {_.times(_.size(academicCriteriaValues), index => {
              return <SkeletonLoader key={index} width={44} height={32} />;
            })}
          </div>
        ) : (
          <CriteriaRating
            shouldUpdateOnValueChnage={true}
            isEvaluation={isEvaluationEnable}
            options={academicCriteriaValues}
            value={_.get(selectedCriteria, "academicCriteriaValue.id", "")}
            isViewMode={showRatingContainerInViewMode || !isEvaluationEnable}
            onCriteriaClick={handleCriteriaClick}
            containerStyle={{
              ...styles.containerStyle,
              ...criteriaRatingStyle,
            }}
            timeOut={500}
            isAISelectedCriteria={isAISelectedCriteria}
            customRatingElementClass={customRatingElementClass}
            customSelectedRatingElement={
              aiCriteria
                ? classes.customAISelectedRatingElement
                : customSelectedRatingElement
            }
          />
        )}
      </div>

      {isStaff && showEvaluationJustification ? (
        <div className={classes.justificationContainer}>
          <AIJustification
            justifications={[justificationMessage]}
            isAIGeneratingResponse={isGeneratingAIResponse}
            aiEvaluationLabel={aiEvaluationLabel}
            isAIResponseAccepted={
              aiAssessmentGradeBoundary?.isDeleted && collapseJustification
            }
          />
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { parentId, assessmentFields } = ownProps;

  const isGeneratingAIResponse = getIsAIGeneratingResponseForTool({
    state,
    studentAssignmentId: parentId,
    assessmentFields,
  });

  return {
    isGeneratingAIResponse,
    userType: _.get(state, "login.userInfo.user_type", ""),
  };
};

const mapActionCreators = {
  handleAssessmentIBScaleCriteriaClick,
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, mapActionCreators)
)(AssessmentIBScaleTool);
